import { render, staticRenderFns } from "./brandschilderen.vue?vue&type=template&id=7390623b&scoped=true"
import script from "./brandschilderen.vue?vue&type=script&lang=js"
export * from "./brandschilderen.vue?vue&type=script&lang=js"
import style0 from "./brandschilderen.vue?vue&type=style&index=0&id=7390623b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390623b",
  null
  
)

export default component.exports